<script>
  import LoginForm from "@/components/login/LoginForm.vue";
  import WelcomeImage from "@/components/login/WelcomeImage.vue";

  export default {
    name: 'LoginIndex',
    components: {LoginForm, WelcomeImage},
    mounted: function () {
      let userInfo = this.$store.getters['user/userData'];
      if (userInfo && userInfo.jwt_token !== '') {
        this.$router.push('/admin/posts');
      }
    }
  }
</script>

<template>
  <div>
    <el-container>
      <el-main width="60%">
        <WelcomeImage />
      </el-main>
      <el-aside width="40%">
        <LoginForm/>
      </el-aside>
    </el-container>
  </div>
</template>

<style scoped>
.el-aside {
  display: flex;
  background-color: #D3DCE6;
  color: #333;
  text-align: center;
  justify-content: center;
  align-items: center;
}

.el-main {
  background-color: #E9EEF3;
  color: #333;
  text-align: center;
}

.el-container {
  height: 100vh;
  display: flex
}
</style>